import React, { useState, useEffect } from 'react';
import { Card, Modal, Form, Button, Select, message, Tag, ConfigProvider, Row, Col, Typography,Table,Input, Divider } from 'antd';
import { NumericFormat } from 'react-number-format'; 
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/es';
import esES from 'antd/es/locale/es_ES';
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import API_BASE_URL from '../components/apiService';
import { useNavigate } from 'react-router-dom';
moment.locale('es');

const { Title } = Typography;

const Jornadas = () => {
  const [jornadas, setJornadas] = useState([]);
  const [ferrys, setFerrys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);   // Página actual
  const [total, setTotal] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [operationalCosts, setOperationalCosts] = useState([]);
  const [totalIngreso, setTotalIngreso] = useState(0);  
  const [userRecaudo, setUserRecaudo] = useState([]); // Nuevo estado para recaudo por usuario
  const [vehiculosTotalDetalle, setVehiculosTotalDetalle] = useState([]); // Nuevo estado para recaudo por usuario
  const [vehiculosTotalDetalleViaje, setVehiculosTotalDetalleViaje] = useState({});
  const [vehiculosTotalMatriculasViaje, setVehiculosTotalMatriculasViaje] = useState({});

  // ✅ NUEVO: total solo de trayectos
  const [totalRecaudoTrayectos, setTotalRecaudoTrayectos] = useState(0);

  const [form] = Form.useForm();
  const navigate = useNavigate();
  
  const getAuthToken = () => {
    return localStorage.getItem('token');
  };

  const fetchJornadas = async () => {
    const token = getAuthToken();
    if (!token) {
      message.error('No estás autenticado');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.get(`${API_BASE_URL}/admin/jornadas/all`, {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          page: currentPage,
          limit: 1,
        },
      });

      const { count, jornadas } = response.data.data;
      setJornadas(jornadas);
      setTotal(count);
      fetchGastos(response.data.data.jornadas[0].fecha_inicio);
      fetchRecaudo(response.data.data.jornadas[0].fecha_inicio);
      fetchVehiculosDetalle(response.data.data.jornadas[0].id_jornada);
    

    } catch (error) {
      message.error('Error al cargar las jornadas');
    } finally {
      setLoading(false);
    }
  };

  const fetchRecaudo = async (fecha) => {
    const token = getAuthToken();
    if (!token) {
      message.error('No estás autenticado');
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/admin/ingresos/user/all?fecha_ini=${fecha}`, {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          fecha_ini: fecha,
        },
      });

      // El formato de respuesta esperado es un array de objetos con nombre y total
      setUserRecaudo(response.data.data.ingresos);  // Guardar el recaudo por usuario
    } catch (error) {
      message.error('Error al cargar los recaudos de los usuarios');
    }
  };

  
  const fetchVehiculosDetalle = async (id_jornada) => {

    const token = getAuthToken();
    if (!token) {
      message.error('No estás autenticado');
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/admin/vehiculos/detaills/all?id_jornada=${id_jornada}`, {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          id_jornada: id_jornada,
        },
      });

      // El formato de respuesta esperado es un array de objetos con nombre y total
      setVehiculosTotalDetalle(response.data.data.details);  // Guardar el recaudo por usuario
    } catch (error) {
      message.error('Error al cargar los recaudos de los usuarios');
    }
  };

  const fetchVehiculosDetalleByViajes = async (id_viaje) => {
    // Si ya se cargaron los detalles de este viaje, no hacer la consulta nuevamente
    if (vehiculosTotalDetalleViaje[id_viaje]) {
      return; // Si ya están cargados, no hacemos la solicitud
    }
  
    const token = getAuthToken();
    if (!token) {
      message.error('No estás autenticado');
      return;
    }
  
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/vehiculos/detaills/viaje/all`, {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          id_viaje: id_viaje,
        },
      });
  
      // Guardar los detalles de vehículos para el viaje específico
      setVehiculosTotalDetalleViaje((prevState) => ({
        ...prevState,
        [id_viaje]: response.data.data.details, // Se asegura que los detalles se almacenen correctamente
      }));
    } catch (error) {
      message.error('Error al cargar los detalles de los vehículos');
    }
  };

  const fetchMatriculas = async (id_viaje,id_tipo_vehiculo) => {
    // Si ya se cargaron los detalles de este viaje, no hacer la consulta nuevamente
    if (vehiculosTotalMatriculasViaje[id_viaje]) {
      return; // Si ya están cargados, no hacemos la solicitud
    }
  
    const token = getAuthToken();
    if (!token) {
      message.error('No estás autenticado');
      return;
    }
  
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/vehiculos/detaills/viaje/matricula`, {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          id_viaje: id_viaje,
          id_tipo_vehiculo:id_tipo_vehiculo
        },
      });
  
      // Guardar los detalles de vehículos para el viaje específico
      setVehiculosTotalMatriculasViaje((prevState) => ({
        ...prevState,
        [`${id_viaje}_${id_tipo_vehiculo}`]: response.data.data.details, // Se asegura que los detalles se almacenen correctamente
      }));
    } catch (error) {
      message.error('Error al cargar los detalles de los vehículos');
    }
  };
  


  const fetchFerrys = async () => {
    const token = getAuthToken();
    if (!token) {
      message.error('No estás autenticado');
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/admin/ferrys/all`, {
        headers: {
          Authorization: `${token}`,
        },
      });

      const ferrysData = response.data.data.ferrys || [];
      setFerrys(ferrysData);
    } catch (error) {
      message.error('Error al cargar los ferrys');
    }
  };

const  navigateTrayecto = () =>{
  navigate('/opentrayecto')
}

const fetchGastos = async (fechaIni = null) => {
  setLoading(true);
  const token = localStorage.getItem('token'); // Obtener el token desde localStorage

  try {
    const params = {
      page:1,
      limit: 10000, // Límite de resultados por página
      fecha_ini: fechaIni  // Añadir fecha inicio si está definida
    };

    const response = await axios.get(
      `${API_BASE_URL}/admin/gastos/all`,
      {
        params,
        headers: {
          Authorization: `${token}` // Pasamos el token en los encabezados
        }
      }
    );

    if (response.data.success) {

      const ingresos = response.data.data.gastos.filter(gasto => gasto.tipo_operacion === 'INGRESO');
      setOperationalCosts(ingresos); // Datos de los trayectos (ingresos)

      // ✅ SUMA DE TRAYECTOS (lo que necesitas ver)
      const totalTrayectos = ingresos.reduce((acc, row) => acc + Number(row.monto || 0), 0);
      setTotalRecaudoTrayectos(totalTrayectos);

      // (opcional) si aún quieres conservar totalIngreso para algo más, lo dejamos igual:
      setTotalIngreso(totalTrayectos);

      setTotal(response.data.data.count);  // Total de registros
    } else {
      message.error('Error al obtener los datos');
    }
  } catch (error) {
    console.error('Error al hacer la solicitud', error);
    message.error('Hubo un error al cargar los datos');
  } finally {
    setLoading(false);
  }
};

  const showModal = () => {
    fetchFerrys();
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const expandedRowRender = (record) => {
    if (!vehiculosTotalDetalleViaje[record.id_viaje]) {
      fetchVehiculosDetalleByViajes(record.id_viaje);
    }
  
    const vehiculosPanel = vehiculosTotalDetalleViaje[record.id_viaje] || [];
  
    return (
      <>
        <Title level={5} style={{color:'red'}}>Cantidad Vehículos del trayecto TR-{record.id_viaje}</Title>
  
        <Table
          dataSource={vehiculosPanel}
          rowKey="tipo_vehiculo_id"
          pagination={false}
          style={{width:'45%'}}
          expandedRowRender={expandedRow} 
          columns={[
            { title: 'Tipo', dataIndex: 'tipo_vehiculo', key: 'tipo_vehiculo' },
            { title: 'Cantidad', dataIndex: 'cantidad', key: 'cantidad' },
          ]}
        />
      </>
    );
  };

  const expandedRow = (record) => {
    if (!vehiculosTotalMatriculasViaje[`${record.id_viaje}_${record.tipo_vehiculo_id}`]) {
      fetchMatriculas(record.id_viaje,record.tipo_vehiculo_id);
    }
  
    const vehiculosPanel = vehiculosTotalMatriculasViaje[`${record.id_viaje}_${record.tipo_vehiculo_id}`] || [];
  
    return (
      <>
        <Table
          dataSource={vehiculosPanel}
          rowKey="tipo_vehiculo_id"
          pagination={false}
          style={{width:'45%'}}
          columns={[
            { title: 'Matricula', dataIndex: 'matricula', key: 'matricula' },
            { title: 'Tarifa', dataIndex: 'precio', key: 'precio' },
          ]}
        />
      </>
    );
  };
  
  
  const handleUpdateEstado = async (idJornada, estado) => {
    const token = getAuthToken();  
    if (!token) {
      message.error('No estás autenticado');
      return;
    }
  
    setLoading(true);
  
    try {
      const response = await axios.post(
        `${API_BASE_URL}/admin/jornadas/status`,
        { id_jornada: idJornada, estado: estado },
        { headers: { Authorization: `${token}` } }
      );
  
      if (response.data.success) {
        message.success('Estado de la jornada actualizado correctamente');
        fetchJornadas();
      } else {
        message.error('Error al actualizar el estado de la jornada');
      }
    } catch (error) {
      console.error('Error al realizar la solicitud:', error);
      message.error('Hubo un error al actualizar la jornada');
    } finally {
      setLoading(false);
    }
  };
  
  const handleCreate = async (values) => {
    setLoading(true);
    const token = getAuthToken();

    try {
      const fechaHoy = moment().startOf('day');
      const fechaInicio = fechaHoy.clone().set({ hour: 4, minute: 0, second: 0, millisecond: 0 });
      const fechaFin = fechaHoy.clone().set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

      const fechaInicioString = fechaInicio.format('YYYY-MM-DD HH:mm:ss');
      const fechaFinString = fechaFin.format('YYYY-MM-DD HH:mm:ss');

      const data = {
        ...values,
        fecha_inicio:fechaInicioString,
        fecha_fin:fechaFinString,
      };

      const response = await axios.post(`${API_BASE_URL}/admin`, data, {
        headers: { Authorization: `${token}` },
      });

      if(response.data.data.jornada_id > 0){
        message.success('Jornada creada correctamente');
        navigate('/opentrayecto');
        setIsModalOpen(false);
        fetchJornadas();
        form.resetFields();
      }

    } catch (error) {
      message.error('Error al crear la jornada');
    } finally {
      setLoading(false);
    }
  };

  const recargarPagina = () => {
    window.location.reload();
  };

  useEffect(() => {
    fetchJornadas();
  }, [currentPage]);

  useEffect(() => {
    if (ferrys.length > 0) {
      form.setFieldsValue({
        id_ferry: ferrys[0]?.id_ferry,
      });
    }
  }, [ferrys, form]);

  // ❌ QUITADO: este useEffect te pisaba el total con userRecaudo (no es suma de trayectos)
  /*
  useEffect(() => {
    if (jornadas.length > 0 && userRecaudo.length > 0) {
      let total = 0;
      userRecaudo.forEach(row => {
        if(row.tipo_operacion == 'INGRESO'){
          total += Number(row.monto);
        }
      });
      setTotalIngreso(total);
    }
  }, [jornadas, userRecaudo]);
  */

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button
          onClick={() => clearFilters && clearFilters()}
          size="small"
          style={{ width: 90 }}
        >
          Limpiar
        </Button>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  });

  const columns = [
    { title: 'Trayecto', dataIndex: 'trayecto', key: 'trayecto', ...getColumnSearchProps('trayecto') },
    {
      title: 'Ingreso',
      dataIndex: 'monto',
      key: 'monto',
      render: (amount) => (
        <NumericFormat value={amount} displayType="text" thousandSeparator={true} fixedDecimalScale />
      ),
    },
    { title: 'Vehículos', dataIndex: 'vehiculos', key: 'vehiculos', ...getColumnSearchProps('vehiculos') },
    { title: 'Fecha', dataIndex: 'fecha_creacion', key: 'fecha_creacion', ...getColumnSearchProps('fecha_creacion') }
  ];

  return (
    <ConfigProvider locale={esES}>
      <Card style={{ margin: '20px 0', padding: '20px' }} bordered={false}>
        <Title level={3} style={{ marginBottom: '20px', textAlign: 'center' }}>
          Jornada 
        </Title>

        <Button type="primary" onClick={showModal} style={{ marginBottom: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto',width:365,height:60 }}>
          Abrir Nueva Jornada
        </Button>
        
        <Button type="primary" onClick={navigateTrayecto} style={{ marginBottom: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto',width:365,height:60 }}>
          VER Trayecto actual
        </Button>

        <Button
          type="primary"
          icon={<ReloadOutlined />}
          onClick={() => recargarPagina()}
          style={{ marginBottom: '10px',width:365,height:60 }}
        >
          Actualizar
        </Button>

        <Row gutter={[16, 16]}>
          {jornadas.map((jornada) => (
            <Col xs={24} sm={12} md={8} lg={6} xl={4} key={jornada.id_jornada}>
              <Card bordered hoverable title={`${jornada.ferry_nombre}`}>
                <p> {"\u00A0"} <strong className='titles'>Codigo de jornada:</strong> {"\u00A0"} J{jornada.id_jornada}</p>
                <p>{"\u00A0"} <strong className='titles'>Fecha Inicio:</strong> {"\u00A0"} {moment(jornada.fecha_inicio).format('YYYY-MM-DD HH:mm:ss')}</p>
                <p>{"\u00A0"} <strong className='titles'>Fecha Fin:</strong> {"\u00A0"} {moment(jornada.fecha_fin).format('YYYY-MM-DD HH:mm:ss')}</p>
                <p>{"\u00A0"} <strong className='titles'>Abierta por:</strong> {"\u00A0"} {jornada.usuario_nombre}</p>
                <p>{"\u00A0"} <strong className='titles'>Estado:</strong> {"\u00A0"} <Tag color={jornada.estado === 1 ? 'green' : 'red'}>{jornada.estado === 1 ? 'Jornada Abierta' : 'Jornada Cerrada'}</Tag></p>

                {userRecaudo.length > 0 ? (
                  <ul>
                    {userRecaudo.map((recaudo, index) => (
                      <li key={index}>
                        <strong className='titles'>Operador:</strong> {recaudo.nombre} <br />
                        <strong className='titles'>recaudo: </strong>
                        <NumericFormat value={recaudo.total_jornada} displayType="text" thousandSeparator={true} prefix="$" decimalScale={2} fixedDecimalScale />
                        <br /><strong className='titles'>Inicio:</strong> {recaudo.fecha_creacion_dos} 
                        <br /><strong className='titles'>Fin:</strong> {recaudo.fecha_creacion} 
                        <Divider></Divider>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No hay recaudos disponibles.</p>
                )}

                {/* ✅ AQUÍ YA SE VE LA SUMA DE LOS TRAYECTOS */}
                <p>
                  {"\u00A0"} <strong className='titles'>Recaudo total:</strong> {"\u00A0"}
                  <NumericFormat
                    value={totalRecaudoTrayectos}
                    displayType="text"
                    thousandSeparator={true}
                    prefix="$"
                    decimalScale={0}
                    fixedDecimalScale
                  />
                </p>

                <Button
                  type="primary"
                  onClick={() => handleUpdateEstado(jornada.id_jornada, jornada.estado === 1 ? 0 : 1)}
                  style={{ marginTop: 10, background:jornada.estado === 1 ? 'red' : 'green'}}
                >
                  {jornada.estado === 1 ? 'Cerrar Jornada' : 'Abrir Jornada'}
                </Button>

                <br /><br />
              </Card>

              <Title level={3} style={{ marginBottom: '20px', textAlign: 'center' ,color:'red'}}>
                TRAYECTOS DEL DIA
              </Title>

              <Table
                columns={columns}
                dataSource={operationalCosts}
                rowKey="id_viaje"
                loading={loading}
                scroll={{ x: 'max-content' }}
                responsive={true}
                expandedRowRender={expandedRowRender}
                footer={() => (
                  <div style={{ textAlign: 'right', fontSize: 20, color: "#00bf3f", fontWeight: 'bold' }}>
                    Total trayectos:{" "}
                    <NumericFormat value={totalRecaudoTrayectos} displayType="text" thousandSeparator={true} prefix="$" decimalScale={0} fixedDecimalScale />
                  </div>
                )}
                pagination={false}
              />

              <Title level={3} style={{ marginBottom: '20px', textAlign: 'center' ,color:'red'}}>
                VEHÍCULOS DE LA JORNADA
              </Title>

              <Table
                columns={[
                  { title: 'Vehículo', dataIndex: 'tipo_vehiculo', key: 'tipo_vehiculo', ...getColumnSearchProps('tipo_vehiculo') },
                  { title: 'Cantidad', dataIndex: 'cantidad', key: 'cantidad', ...getColumnSearchProps('cantidad') }
                ]}
                dataSource={vehiculosTotalDetalle}
                rowKey="tipo_vehiculo"
                loading={loading}
                scroll={{ x: 'max-content' }}
                responsive={true}
                pagination={false}
              />

              <Table
                columns={[
                  { title: 'Total', dataIndex: 'total', key: 'total' }
                ]}
                dataSource={vehiculosTotalDetalle.slice(0, 1)}
                rowKey="id_tipo_vehiculo"
                loading={loading}
                scroll={{ x: 'max-content' }}
                responsive={true}
                pagination={false}
              />
            </Col>
          ))}
        </Row>

        <Modal
          title="Abrir Jornada"
          visible={isModalOpen}
          onCancel={handleCancel}
          footer={null}
          destroyOnClose
          width={600}
        >
          <Form form={form} onFinish={handleCreate} layout="vertical">
            <Form.Item
              name="id_ferry"
              label="Ferry"
              rules={[{ required: true, message: 'Selecciona un ferry' }]}
            >
              <Select placeholder="Selecciona un ferry">
                {ferrys.map((ferry) => (
                  <Select.Option key={ferry.id_ferry} value={ferry.id_ferry}>
                    {ferry.ferry}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Button type="primary" htmlType="submit" block loading={loading}>
              ENVIAR
            </Button>
          </Form>
        </Modal>
      </Card>
    </ConfigProvider>
  );
};

export default Jornadas;
